<template>
    <div class="notice__item d-flex">
        <div class="notice__item-header">
            <a class="notice__item-avatar" :href="`/user/${notice.sender_id}/profile`" v-if="notice.sender">
                <img :src="`/storage` + notice.sender.avatar.path | convertImage('avatar')" :alt="getUserPM(notice.sender.name)" v-if="notice.sender.avatar">
                <span v-text="getUserPM(notice.sender.name)"></span>
            </a>
            <div class="notice__item-avatar" v-else>
                <span v-text="getUserPM($store.getters.t('common_administrator'))"></span>
            </div>
        </div>

        <div class="notice__item-body">
            <div class="notice__item-body-header">
                <a class="notice__user-name" :href="`/user/${notice.sender_id}/profile`" v-text="notice.sender.name" v-if="notice.sender"></a>
                <span class="notice__user-name" v-else>{{$store.getters.t('common_administrator')}}</span>
                {{notice.text}}:

                <template v-if="notice && notice.type === 'expenditure_transaction' && notice.moderatedObject">
                    <template v-if="notice.moderatedObject.source && (notice.moderatedObject.source_type || notice.moderatedObject.source.type) &&
                                    notice.moderatedObject.source.name && notice.moderatedObject.source.id ">
                        <span>{{$store.getters.t('notice_from')}}</span>
                        <a :href="`/pets/${notice.moderatedObject.source.id}`"
                           v-if="notice.moderatedObject.source.type === 'PET_TYPE_MYSELF' || notice.moderatedObject.source.type === 'PET_TYPE_VOLUNTEER'">{{ notice.moderatedObject.source.name }}</a>

                        <a :href="`/projects/${notice.moderatedObject.target.id}`"
                           v-else-if="(notice.moderatedObject.source_type && notice.moderatedObject.source_type.indexOf('Project') >= 0)">
                            {{ notice.moderatedObject.source.name }}</a>

                    </template>

                    <template v-if="notice.moderatedObject.target && (notice.moderatedObject.target_type || notice.moderatedObject.target.type) &&
                                    notice.moderatedObject.target.name && notice.moderatedObject.target.id">

                        <span>{{$store.getters.t('notice_for')}}</span>
                        <a :href="`/pets/${notice.moderatedObject.target.id}`"
                           v-if="notice.moderatedObject.target.type === 'PET_TYPE_MYSELF' || notice.moderatedObject.target.type === 'PET_TYPE_VOLUNTEER'">{{ notice.moderatedObject.target.name }}</a>

                        <a :href="`/projects/${notice.moderatedObject.target.id}`"
                           v-else-if="(notice.moderatedObject.target_type && notice.moderatedObject.target_type.indexOf('Project') >= 0)">
                            {{ notice.moderatedObject.target.name }}</a>

                    </template>
                </template>
                <template v-else-if="notice.type === 'transaction_got_funds' && notice.details">

                    <template v-if="notice.details.payment_data && notice.details.payment_data.source &&
                                    notice.details.payment_data.source.name && notice.details.payment_data.source.id ">
                        <span>{{$store.getters.t('notice_from')}}</span>
                        <a :href="`/pets/${notice.details.payment_data.source.id}`"
                           v-if="notice.details.payment_data.source.type && notice.details.payment_data.source.type === 'PET_TYPE_MYSELF' || notice.details.payment_data.source.type === 'PET_TYPE_VOLUNTEER'">
                            {{ notice.details.payment_data.source.name }}</a>

                        <a :href="`/projects/${notice.details.payment_data.target.id}`"
                           v-else-if="!notice.details.payment_data.source.type">
                            {{ notice.details.payment_data.source.name }}</a>

                    </template>
                    <template v-if="notice.object && notice.object.type && notice.details && notice.details.object_type && notice.object.name && notice.object.id">
                        <span>{{$store.getters.t('notice_for')}}</span>
                        <a :href="`/pets/${notice.object.id}`"
                           v-if="notice.object.type === 'PET_TYPE_MYSELF' || notice.object.type === 'PET_TYPE_VOLUNTEER'">{{ notice.object.name }}</a>
                        <a :href="`/projects/${notice.object.id}`"
                           v-else-if="notice.details.object_type.indexOf('Project') >= 0">
                            {{ notice.object.name }}</a>
                    </template>

                </template>
                <template v-else-if="notice.object">
                    <a :href="`/pets/${notice.object.id}`"
                       v-if="notice.object.type === 'PET_TYPE_MYSELF' || notice.object.type === 'PET_TYPE_VOLUNTEER'">{{ notice.object.name }}</a>
                    <a :href="`/projects/${notice.object.id}`"
                       v-else-if="notice.details.object_type.indexOf('Project') >= 0">
                        {{ notice.object.name }}</a>
                    <span v-else-if="notice.details.object_type.indexOf('Organization') >= 0"><strong style="color: #555; font-weight: 700">{{notice.object.name}}</strong></span>
                    <a :href="`/user/${notice.object.id}/profile`" v-else>{{ notice.object.name }}</a>
                </template>

            </div>
            <div class="notice__item-body-content">

                <div v-if="notice.details.payment_data && notice.details.payment_data.desc">
                    {{notice.details.payment_data.desc}}
                </div>
                <div class="comment" v-if="notice.details.payment_data && notice.details.payment_data.comment">
                   {{$store.getters.t('notice_accountant_comment')}}: "{{notice.details.payment_data.comment}}"
                </div>
                <div class="notice__item-currency">
                    <template v-if="notice.details.payment_data && notice.details.payment_data.amount">{{notice.details.payment_data.amount}}</template>
                    <template v-else-if="notice.details && notice.details.amount">{{notice.details.amount}}</template>

                    <template v-if="notice.details.payment_data && notice.details.payment_data.currency && notice.details.payment_data.currency.code">{{notice.details.payment_data.currency.code}}</template>
                    <template v-else>EUR</template>
                </div>

            </div>

            <div class="time">{{$store.getters.t('notice_status_updated')}} <span>{{ moment(notice.created_at).format('DD.MM.YYYY') }}</span></div>
            <div class="notice__item-body-icon-wrapper">
                <div class="notice__item-body-icon d-flex" :style="{backgroundColor: getNoticeIcon(notice.type).color}">
                    <img :src="getNoticeIcon(notice.type).icon" alt="">
                </div>
                <div class="notice__item-body-icon-status" v-if="notice.status === 'unread'"></div>
            </div>

            <a href="#" @click.prevent="removeNotice(notice.id)" class="notice__item-body-remove">
                <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.5 15H2.5C2.10218 15 1.72064 14.842 1.43934 14.5607C1.15804 14.2794 1 13.8978 1 13.5V4C1 3.86739 1.05268 3.74021 1.14645 3.64645C1.24021 3.55268 1.36739 3.5 1.5 3.5C1.63261 3.5 1.75979 3.55268 1.85355 3.64645C1.94732 3.74021 2 3.86739 2 4V13.5C2 13.6326 2.05268 13.7598 2.14645 13.8536C2.24021 13.9473 2.36739 14 2.5 14H10.5C10.6326 14 10.7598 13.9473 10.8536 13.8536C10.9473 13.7598 11 13.6326 11 13.5V4C11 3.86739 11.0527 3.74021 11.1464 3.64645C11.2402 3.55268 11.3674 3.5 11.5 3.5C11.6326 3.5 11.7598 3.55268 11.8536 3.64645C11.9473 3.74021 12 3.86739 12 4V13.5C12 13.8978 11.842 14.2794 11.5607 14.5607C11.2794 14.842 10.8978 15 10.5 15Z" fill="#CED4DA"/>
                    <path d="M12.5 3H0.5C0.367392 3 0.240215 2.94732 0.146447 2.85355C0.0526784 2.75979 0 2.63261 0 2.5C0 2.36739 0.0526784 2.24021 0.146447 2.14645C0.240215 2.05268 0.367392 2 0.5 2H12.5C12.6326 2 12.7598 2.05268 12.8536 2.14645C12.9473 2.24021 13 2.36739 13 2.5C13 2.63261 12.9473 2.75979 12.8536 2.85355C12.7598 2.94732 12.6326 3 12.5 3Z" fill="#CED4DA"/>
                    <path d="M8.5 3C8.36739 3 8.24021 2.94732 8.14645 2.85355C8.05268 2.75979 8 2.63261 8 2.5V1H5V2.5C5 2.63261 4.94732 2.75979 4.85355 2.85355C4.75979 2.94732 4.63261 3 4.5 3C4.36739 3 4.24021 2.94732 4.14645 2.85355C4.05268 2.75979 4 2.63261 4 2.5V0.5C4 0.367392 4.05268 0.240215 4.14645 0.146447C4.24021 0.0526784 4.36739 0 4.5 0H8.5C8.63261 0 8.75979 0.0526784 8.85355 0.146447C8.94732 0.240215 9 0.367392 9 0.5V2.5C9 2.63261 8.94732 2.75979 8.85355 2.85355C8.75979 2.94732 8.63261 3 8.5 3Z" fill="#CED4DA"/>
                    <path d="M6.5 12.5C6.36739 12.5 6.24021 12.4473 6.14645 12.3536C6.05268 12.2598 6 12.1326 6 12V5C6 4.86739 6.05268 4.74021 6.14645 4.64645C6.24021 4.55268 6.36739 4.5 6.5 4.5C6.63261 4.5 6.75979 4.55268 6.85355 4.64645C6.94732 4.74021 7 4.86739 7 5V12C7 12.1326 6.94732 12.2598 6.85355 12.3536C6.75979 12.4473 6.63261 12.5 6.5 12.5Z" fill="#CED4DA"/>
                    <path d="M9 11.5C8.86739 11.5 8.74021 11.4473 8.64645 11.3536C8.55268 11.2598 8.5 11.1326 8.5 11V6C8.5 5.86739 8.55268 5.74021 8.64645 5.64645C8.74021 5.55268 8.86739 5.5 9 5.5C9.13261 5.5 9.25979 5.55268 9.35355 5.64645C9.44732 5.74021 9.5 5.86739 9.5 6V11C9.5 11.1326 9.44732 11.2598 9.35355 11.3536C9.25979 11.4473 9.13261 11.5 9 11.5Z" fill="#CED4DA"/>
                    <path d="M4 11.5C3.86739 11.5 3.74021 11.4473 3.64645 11.3536C3.55268 11.2598 3.5 11.1326 3.5 11V6C3.5 5.86739 3.55268 5.74021 3.64645 5.64645C3.74021 5.55268 3.86739 5.5 4 5.5C4.13261 5.5 4.25979 5.55268 4.35355 5.64645C4.44732 5.74021 4.5 5.86739 4.5 6V11C4.5 11.1326 4.44732 11.2598 4.35355 11.3536C4.25979 11.4473 4.13261 11.5 4 11.5Z" fill="#CED4DA"/>
                </svg>
            </a>

        </div>
    </div>
</template>

<script>
export default {
    name: "NoticePayments",
    props: ['notice'],
    data(){
        return{
            moment: window.moment,
        }
    },

    methods:{

        removeNotice(id){
            let url = `/api/notifications/${id}`

            axios.delete(url)
                .then(response => {
                    response = response.data
                    if(response.success){
                        this.$emit('refreshTab')
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        alert(error.response.data.message);
                    }
                })

        },


        getNoticeIcon(noticeType){
            let result = {}
            switch (noticeType){
                case 'transaction_done':
                case 'expenditure_transaction':
                    result = {
                        icon: '/assets/images/icons/money.svg',
                        color: '#F4FBF0'
                    }
                    break;
                default:
                    result = {
                        icon: '/assets/images/icons/money.svg',
                        color: '#F4FBF0'
                    }
            }

            return result

        },

        getUserPM(name){
            if(!name) {
                return '';
            }
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },
    }
}
</script>

<style scoped>

</style>
